if (!customElements.get('pf-fidelity-carousel')) {
  customElements.define('pf-fidelity-carousel', class extends HTMLElement {
    connectedCallback() { this.pending = requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.track = this.querySelector('[data-pf-track]');
      this.slides = [...this.querySelectorAll('[data-pf-slide]')];
      this.buttons = [...this.querySelectorAll('[data-pf-go]')];
      if (!this.track || !this.slides.length) return;
      this.current = 0;
      this.buttons.forEach((button, i) => button.addEventListener('click', () => this.go(i), options));
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const next = (this.current + (event.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length;
        this.go(next);
        this.buttons[next]?.focus({preventScroll: true});
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => {
          const width = this.track.clientWidth;
          if (width) this.activate(Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width))));
        });
      }, {...options, passive: true});
      this.resize = new ResizeObserver(() => {this.track.scrollTo({left:this.current*this.track.clientWidth,behavior:'instant'});});
      this.resize.observe(this.track);
      this.activate(0);
      this.startAuto();
      this.addEventListener('mouseenter',()=>this.stopAuto(),options);
      this.addEventListener('mouseleave',()=>this.startAuto(),options);
      this.addEventListener('focusin',()=>this.stopAuto(),options);
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))this.startAuto();},options);
    }
    startAuto() {
      this.stopAuto();
      if (this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.auto = setInterval(() => this.go((this.current + 1) % this.slides.length), 6500);
    }
    stopAuto() { if (this.auto) { clearInterval(this.auto); this.auto = null; } }
    go(index) {
      this.track.scrollTo({left: this.track.clientWidth * index, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.activate(index);
    }
    activate(index) {
      this.current = index;
      this.buttons.forEach((button, i) => i === index ? button.setAttribute('aria-current', 'true') : button.removeAttribute('aria-current'));
      this.slides.forEach((slide, i) => {slide.inert = i !== index;});
    }
    disconnectedCallback() {this.stopAuto();cancelAnimationFrame(this.pending); this.controller?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.raf);}
  });
}
if (!window.prefireFidelityListeners) {
  window.prefireFidelityListeners = true;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-pf-localization] select');
    if (select) select.form.requestSubmit();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('[data-pf-menu][open]');
    if (menu) {menu.open = false; menu.querySelector('summary')?.focus();}
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('[data-pf-menu][open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
}
